import { IApplicationState, TBoardId } from '../../../../types/types';
import { IRestUserBoardMeta } from '../../../../types/rest/IRestUserBoardMeta';
import { getInitialState } from 'app/store/model/boardUserMeta/reducers/boardUserMetaReducer';

export const getBoardUserMeta = (
    state: IApplicationState,
    boardId: TBoardId
): IRestUserBoardMeta => {
    return state.model.boardUserMetas[boardId] || getInitialState();
}
